// Youssef Selkani
// 2019

import React, { Component } from 'react'

import { BrowserRouter as Router, Route } from 'react-router-dom'
import './App.css'

import Home from './routes/Home'
import Build from './routes/Build'
import Terms from './routes/Terms'
import Privacy from './routes/Privacy'
import Account from './routes/Account'
import Help from './routes/Help'
import Thanks from './routes/Thanks'
import Contact from './routes/Contact'

import fire from 'firebase'

import {
  Container,
  Grid,
  List,
  Segment,
  Header,
  Menu,
  Divider,
  Image,
  Icon,
  Button
} from 'semantic-ui-react'

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null,
      loggedIn: null,
      loading: true,
      maintenance: false,
      unstable: false
    }
  }

  logout () {
    fire.auth().signOut()
  }

  componentWillMount = () => {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ loggedIn: true, loading: false })
      } else {
        this.setState({ loggedIn: false, loading: false })
      }
    })
  }

  render () {
    let { loggedIn, loading } = this.state
    return (
      <Router>
        <div className='App'>
          <Menu
            borderless
            style={{
              border: 'none',
              borderRadius: 0,
              boxShadow: 'none',
              marginBottom: '0em',
              backgroundColor: '#fff',
              color: '#111',
              padding: '2vh'
            }}
          >
            <Container>
              <Menu.Item>
                <Image size='mini' src='images/logo.png' alt='logo' />
              </Menu.Item>
              <Menu.Item header href='/'>
                Monosfer
              </Menu.Item>
              {!loggedIn && !loading && (
                <Menu.Item position='right' href='/account'>
                  <Button basic color='black'>
                    Get started
                  </Button>
                </Menu.Item>
              )}
              {/* {loggedIn && !loading && (
                <Menu.Item href='/build'>
                  <Icon name='lab' />
                  Build
                </Menu.Item>
              )} */}
              {loggedIn && !loading && (
                <Menu.Item
                  href='/'
                  position='right'
                  onClick={() => this.logout()}
                >
                  <Icon name='log out' />
                  Log out
                </Menu.Item>
              )}
            </Container>
          </Menu>

          <Route path='/' exact component={Home} />
          <Route path='/terms' component={Terms} />
          <Route path='/privacy' component={Privacy} />
          <Route path='/account' component={Account} />
          <Route path='/build' component={Build} />
          <Route path='/help' component={Help} />
          <Route path='/thanks' component={Thanks} />
          <Route path='/contact' component={Contact} />

          <Divider hidden />

          {/* Footer */}
          <Container style={{ backgroundColor: '#fff', width: '100%' }}>
            <Segment vertical style={{ padding: '7em 3em' }}>
              <Container>
                <Grid divided stackable>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <Header as='h4' content='Contact' />
                      <List link>
                        <List.Item>
                          <List.Icon name='mail' />
                          <List.Content>
                            <a href='mailto:hello@chrysntm.com'>Email</a>
                          </List.Content>
                        </List.Item>
                        {/* <List.Item as="h6">Images by Unsplash.com</List.Item> */}
                      </List>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Header as='h4' content='Social' />
                      <List link>
                        <List.Item
                          href='https://twitter.com/usfslk'
                          target='_blank'
                          as='a'
                        >
                          <List.Icon name='twitter' />
                          <List.Content>Twitter</List.Content>
                        </List.Item>
                        <List.Item
                          href='https://instagram.com/chrysntm'
                          target='_blank'
                          as='a'
                        >
                          <List.Icon name='instagram' />
                          <List.Content>Instagram</List.Content>
                        </List.Item>
                        <List.Item
                          as='a'
                          href='https://angel.co/usfslk'
                          target='_blank'
                        >
                          <List.Icon name='angellist' />
                          <List.Content>Angel.co</List.Content>
                        </List.Item>
                      </List>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Header as='h4' content='Legal' />
                      <List link>
                        <List.Item href='/help' as='a'>
                          Help Center
                        </List.Item>
                        <List.Item href='/privacy' as='a'>
                          Privacy Policy
                        </List.Item>
                        <List.Item href='/terms' as='a'>
                          Terms of Service
                        </List.Item>
                      </List>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Segment>
          </Container>
        </div>
      </Router>
    )
  }
}

export default App
